import React from 'react';

const MissionSection = () => {
  return (
    <section className="bg-gradient-to-br from-teal to-teal/80 py-20 md:py-32">
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <div className="mb-8">
          <div className="inline-block h-1 w-24 bg-dull-gold mb-8"></div>
        </div>
        
        <p className="font-nunito text-cream text-base md:text-lg lg:text-xl leading-relaxed md:leading-loose">
          At Brunch Club Hospitality, we are dedicated to redefining dining through
          personalized luxury experiences that cater to your unique tastes and
          preferences. We believe that every visit should be more than just a meal
          - it should be an unforgettable journey into culinary excellence.
          Whether you're indulging in our diverse restaurant offerings or exploring
          entrepreneurial opportunities, our mission is to ensure that every aspect
          of your experience is tailored to meet your highest expectations. With a
          focus on innovation and quality, we strive to set new standards in the
          hospitality industry.
        </p>

        <div className="mt-8">
          <div className="inline-block h-1 w-24 bg-dull-gold"></div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;

